import { ProtectedRoute } from '@/entities/protected-route'
import { AccountLayout } from './AccountLayout'

/**
 * Account section shell behind the auth gate. Extracted so the route table in
 * routes.ts stays JSX-free: it can reference this via `Component` instead of
 * composing `<ProtectedRoute><AccountLayout /></ProtectedRoute>` inline.
 */
export function ProtectedAccountLayout() {
  return (
    <ProtectedRoute>
      <AccountLayout />
    </ProtectedRoute>
  )
}
